export const EVENTS_CACHE_KEYS = {
  EVENTS_LIST: 'events-list',
  HIGHLIGHTED_EVENTS: 'highlighted-events',
};

export type FilterOption = {
  id: string;
  label: string;
};

export const sortByOptions: FilterOption[] = [
  { id: 'NEWEST', label: 'newest' },
  { id: 'EARLIEST', label: 'earliest' },
  { id: 'TRENDING', label: 'trending' },
  { id: 'LOW_ACTIVITY', label: 'low activity' },
];

export const statusOptions: FilterOption[] = [
  { id: 'ALL', label: 'all' },
  { id: 'UPCOMING', label: 'upcoming' },
  { id: 'REGISTRATION_OPENS', label: 'registration opens' },
  { id: 'ONGOING', label: 'ongoing' },
  { id: 'REWARD_DISTRIBUTION', label: 'reward distribution' },
  { id: 'FINISHED', label: 'finished' },
];

export const specialOptions: FilterOption[] = [{ id: 'VIP_ONLY', label: 'vip-only' }];

export const rewardTypeOptions: FilterOption[] = [
  { id: 'ALL', label: 'all' },
  { id: 'RMV', label: 'rmv' },
  { id: 'NFT', label: 'nft' },
  { id: 'SPINS', label: 'spins' },
];

export type FiltersState = {
  sortBy: string;
  status: Record<string, boolean>;
  eventType: string;
  search: string;
  special: Record<string, boolean>;
  rewardType: Record<string, boolean>;
};

export const DEFAULT_SORT_BY = 'NEWEST';
export const initialFiltersState: FiltersState = {
  sortBy: DEFAULT_SORT_BY,
  status: {
    ALL: false,
    UPCOMING: true,
    REGISTRATION_OPENS: true,
    ONGOING: true,
    REWARD_DISTRIBUTION: true,
    FINISHED: false,
  },
  eventType: 'all',
  search: '',
  special: {
    VIP_ONLY: false,
  },
  rewardType: {
    ALL: true,
    RMV: false,
    NFT: false,
    SPINS: false,
  },
};

export const DEFAULT_EVENT_IMAGE = 'https://placehold.co/600x400';
export const USE_MOCK_DATA = false;
export const FEATURED_SLIDER_AUTOPLAY_DELAY = 7000;
export const FEATURED_SLIDER_TRANSITION_DURATION = 450;
export const FEATURED_SLIDER_TRANSITION_DISTANCE = 1600;
export const FEATURED_SLIDER_FADE_DURATION = 500;
